import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

export interface SendVoidfixMessagePayload {
  recipient: string;
  senderName: string;
  message?: string;
  mediaBase64?: string;
  mediaFilename?: string;
  mediaContentType?: string;
  iMessageLineId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class VoidfixSmsService {
  get apiBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  constructor(private readonly _dataService: DataService) {}

  sendMessage(payload: SendVoidfixMessagePayload): Observable<unknown> {
    const url = `${this.apiBaseUrl}api/v1/voidfix/messages/send`;
    return this._dataService.post(url, payload);
  }

  /** Normalize a phone value to E.164 for Voidfix `recipient`. */
  toE164Recipient(raw: string | null | undefined): string {
    const trimmed = String(raw ?? '').trim();
    if (!trimmed) {
      return '';
    }
    if (trimmed.startsWith('+')) {
      return trimmed;
    }
    const digits = trimmed.replace(/\D/g, '');
    if (digits.length === 10) {
      return `+1${digits}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
      return `+${digits}`;
    }
    return trimmed;
  }
}
